import { styled } from '@compiled/react';

import { token } from '@atlaskit/tokens';

// right-align the dialog actions in the footer
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const DialogActionsContainer = styled.div({
	display: 'flex',
	justifyContent: 'flex-end',
	width: '100%',
	paddingBottom: token('space.300', '24px'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const DiscardDraftContainer = styled.div({
	marginTop: token('space.200', '16px'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const DiscardDraftHeader = styled.div({
	lineHeight: '24px',
	display: 'flex',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'> span[role="img"]': {
		marginRight: token('space.150', '12px'),
	},
});
